<template>
  <span class="icon-text-area">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_4653_26163)">
        <path d="M3.33203 6.66699H16.6654" :stroke="color" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.33203 13.333H16.6654":stroke="color" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_4653_26163">
          <rect :style="`width:${width}px;height:${width}px;fill:white;`"/>
        </clipPath>
      </defs>
    </svg>
  </span>
</template>


<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['secondary-500'] } },
  }
}
</script>